import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.some.js";
import store from '@/store';
export default {
  mounted: function mounted(el, binding, vnode) {
    var value = binding.value;
    var permissions = store.getters && store.getters['user/userPermission'];
    var hasPermission = false;
    if (Array.isArray(value)) {
      hasPermission = permissions.some(function (v) {
        return value.includes(v.permissionCode);
      });
    } else {
      hasPermission = permissions.find(function (v) {
        return v.permissionCode === value;
      });
    }
    if (!hasPermission) el.parentNode && el.parentNode.removeChild(el);
  }
};